import ConfigClient, {getMarketConfigList} from './configClient';

const envUrl = 'https://fwuwa-qa.iot.qa-pmidce.com';
const rrpEnvUrl = 'https://fwuwa-qa.rrp-backend.com';
const deepEnvUrl = 'https://pmi-app-fwuwa-qa.rrp-backend.com';

const marketConfigsList = getMarketConfigList((marketName) => {
    return {
        urls: [`${envUrl}/${marketName}`, `${rrpEnvUrl}/${marketName}`, `${deepEnvUrl}/${marketName}`],
        configImport: () => import(`../marketConfigs/${marketName}/qa-web`),
    };
});

export default class ConfigClientQA extends ConfigClient {
    constructor() {
        super(marketConfigsList);
    }
}
